/* src/app/core/developers/developers.component.scss */
:host {
  display: block;
  height: 100vh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  font-family:
    "Inter Tight",
    "Roboto",
    sans-serif;
  color: var(--cf-text);
  background: var(--cf-bg);
}
.topbar {
  position: sticky;
  top: 0;
  z-index: 20;
  background: var(--cf-chrome);
}
.topbar-inner {
  display: flex;
  align-items: center;
  gap: 16px;
  height: 60px;
  padding: 0 24px;
}
.menu-toggle {
  display: none;
  background: none;
  border: none;
  color: var(--cf-text-on-dark);
  cursor: pointer;
  padding: 4px;
}
.brand {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}
.brand-logo {
  height: 24px;
}
.brand-sep {
  color: rgba(255, 255, 255, 0.25);
  font-size: 18px;
  font-weight: 300;
}
.brand-title {
  color: var(--cf-text-on-dark);
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.01em;
}
.topbar-actions {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 14px;
}
.version-badge {
  display: none;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.03em;
  color: rgba(255, 255, 255, 0.55);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 20px;
  padding: 4px 12px;
}
@media (min-width: 560px) {
  .version-badge {
    display: inline-block;
  }
}
.btn-back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: 1px solid rgba(255, 255, 255, 0.18);
  color: var(--cf-text-on-dark);
  padding: 7px 16px;
  border-radius: var(--cf-radius);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}
.btn-back .btn-icon {
  font-size: 16px;
  height: 16px;
  width: 16px;
}
.btn-back:hover {
  background: rgba(227, 253, 100, 0.12);
  border-color: var(--cf-brand);
  color: var(--cf-brand-dark);
}
.scroll-progress {
  height: 2px;
  background: var(--cf-brand);
  width: 0;
  transition: width 0.1s linear;
}
.body-layout {
  display: flex;
  align-items: flex-start;
}
.sidebar-backdrop {
  display: none;
}
.docs-sidebar {
  position: sticky;
  top: 60px;
  flex: 0 0 240px;
  height: calc(100vh - 60px);
  overflow-y: auto;
  padding: 20px 16px 40px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  background: var(--cf-surface);
  border-right: 1px solid var(--cf-border);
}
.nav-group-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--cf-text-disabled);
  padding: 16px 12px 6px;
}
.nav-group-label:first-child {
  padding-top: 4px;
}
.docs-sidebar a {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  border-radius: var(--cf-radius);
  color: var(--cf-text-muted);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}
.docs-sidebar a mat-icon {
  font-size: 18px;
  height: 18px;
  width: 18px;
  opacity: 0.6;
  transition: opacity 0.15s ease;
}
.docs-sidebar a:hover {
  background: var(--cf-surface-hover);
  color: var(--cf-text);
}
.docs-sidebar a.active {
  background: rgba(227, 253, 100, 0.12);
  color: var(--cf-brand-dark);
  font-weight: 700;
}
.docs-sidebar a.active mat-icon {
  opacity: 1;
  color: var(--cf-brand-dark);
}
.content {
  flex: 1;
  min-width: 0;
  padding: 0 48px 80px;
}
.content-inner {
  max-width: 780px;
  margin: 0 auto;
}
.intro-banner {
  padding: 40px 0 8px;
}
.intro-banner h1 {
  font-size: 28px;
  font-weight: 700;
  color: var(--cf-text);
  margin: 0;
  letter-spacing: -0.01em;
}
.intro-banner p {
  font-size: 15px;
  color: var(--cf-text-muted);
  margin: 8px 0 0;
}
.content section {
  margin-bottom: 56px;
  scroll-margin-top: 76px;
}
.content h2 {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 20px;
  font-weight: 700;
  color: var(--cf-text);
  border-bottom: 1px solid var(--cf-border);
  padding-bottom: 12px;
  margin-bottom: 16px;
}
.content h2 mat-icon {
  color: var(--cf-brand-dark);
  font-size: 20px;
  height: 20px;
  width: 20px;
}
.content h3 {
  font-size: 15px;
  font-weight: 700;
  color: var(--cf-text);
  margin: 24px 0 8px;
}
.content p {
  line-height: 1.65;
  font-size: 14px;
  color: var(--cf-text-muted);
}
.content code {
  background: var(--cf-surface-hover);
  border: 1px solid var(--cf-border);
  padding: 2px 6px;
  border-radius: var(--cf-radius-sm);
  font-size: 12.5px;
  color: var(--cf-brand-dark);
  font-family:
    "Consolas",
    "Monaco",
    monospace;
}
.method-badge {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.03em;
  margin-right: 6px;
}
.method-badge.get {
  background: #e8f4ff;
  color: #0366d6;
}
.method-badge.post {
  background: var(--cf-brand-light);
  color: var(--cf-brand-dark);
}
.status-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: var(--cf-radius-sm);
  font-weight: 700;
  font-size: 12px;
}
.status-badge.s400,
.status-badge.s404,
.status-badge.s409 {
  background: var(--cf-warning-light);
  color: var(--cf-warning-dark);
}
.status-badge.s401 {
  background: var(--cf-surface-hover);
  color: var(--cf-text-muted);
}
.status-badge.s500 {
  background: var(--cf-error-light);
  color: var(--cf-error-dark);
}
.spec-table {
  width: 100%;
  border-collapse: collapse;
  margin: 12px 0 20px;
  font-size: 13px;
  background: var(--cf-surface);
  border: 1px solid var(--cf-border);
  border-radius: var(--cf-radius);
  overflow: hidden;
}
.spec-table th,
.spec-table td {
  text-align: left;
  padding: 10px 14px;
  border-bottom: 1px solid var(--cf-border);
}
.spec-table tr:last-child td {
  border-bottom: none;
}
.spec-table th {
  background: var(--cf-surface-hover);
  color: var(--cf-text-muted);
  font-weight: 600;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}
.endpoint {
  margin-bottom: 32px;
  padding-bottom: 24px;
  border-bottom: 1px dashed var(--cf-border);
}
.endpoint:last-child {
  border-bottom: none;
  padding-bottom: 0;
  margin-bottom: 0;
}
.date-formats {
  list-style: none;
  padding: 0;
  margin: 12px 0;
}
.date-formats li {
  padding: 10px 14px;
  background: var(--cf-surface);
  border: 1px solid var(--cf-border);
  border-radius: var(--cf-radius);
  margin-bottom: 6px;
  font-size: 14px;
}
.warning {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  background: var(--cf-warning-light);
  border: 1px solid var(--cf-brand-border);
  border-radius: var(--cf-radius);
  padding: 12px 16px;
  margin-top: 12px;
}
.warning mat-icon {
  color: var(--cf-brand-dark);
  flex: none;
}
.changelog {
  list-style: none;
  padding: 0;
}
.changelog li {
  border-left: 3px solid var(--cf-brand);
  padding: 4px 16px;
  margin-bottom: 12px;
  font-size: 14px;
  line-height: 1.6;
}
.docs-footer {
  margin-top: 60px;
  padding-top: 20px;
  border-top: 1px solid var(--cf-border);
  font-size: 13px;
  color: var(--cf-text-disabled);
}
.docs-footer a {
  color: var(--cf-brand-dark);
  font-weight: 600;
}
@media (max-width: 860px) {
  .menu-toggle {
    display: block;
  }
  .brand-title {
    display: none;
  }
  .sidebar-backdrop {
    display: block;
    position: fixed;
    inset: 60px 0 0 0;
    background: rgba(0, 0, 0, 0.35);
    z-index: 15;
  }
  .docs-sidebar {
    position: fixed;
    top: 60px;
    left: -260px;
    width: 240px;
    height: calc(100vh - 60px);
    z-index: 16;
    box-shadow: var(--cf-shadow-lg);
    transition: left 0.25s ease;
  }
  .docs-sidebar.open {
    left: 0;
  }
  .content {
    padding: 0 20px 60px;
  }
  .intro-banner {
    padding-top: 28px;
  }
  .intro-banner h1 {
    font-size: 22px;
  }
}
/*# sourceMappingURL=developers.component.css.map */
